// #413 — "Show in list": scroll the event's row into view and pulse it once, or open the event when no row is on screen.
// It never touches seen, read or acknowledged.
export const ALERT_ROW_ATTR = 'data-alert-row'
export const PULSE_MS = 1200

const pulseTimers = new WeakMap<HTMLElement, ReturnType<typeof setTimeout>>()

/** The first row of this event that is really on the page (a hidden one, e.g. under an expanded map, has no client rects). */
export function findAlertRow(eventId: number): HTMLElement | null {
  const rows = document.querySelectorAll<HTMLElement>(`[${ALERT_ROW_ATTR}="${eventId}"]`)
  for (const el of Array.from(rows)) if (el.getClientRects().length > 0) return el
  return null
}

function prefersReducedMotion(): boolean {
  try {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  } catch {
    return false
  }
}

export function showInList(eventId: number, openEvent: () => void, opts?: { focus?: boolean }): 'shown' | 'opened' {
  const el = findAlertRow(eventId)
  if (!el) {
    openEvent()
    return 'opened'
  }
  el.scrollIntoView?.({ block: 'nearest', behavior: prefersReducedMotion() ? 'auto' : 'smooth' })
  const previous = pulseTimers.get(el)
  if (previous) clearTimeout(previous)
  el.removeAttribute('data-alert-pulse')
  void el.offsetWidth // restart the animation
  el.setAttribute('data-alert-pulse', '')
  pulseTimers.set(el, setTimeout(() => { el.removeAttribute('data-alert-pulse'); pulseTimers.delete(el) }, PULSE_MS))
  if (opts?.focus) {
    const target = el.tagName === 'BUTTON' ? el : el.querySelector<HTMLElement>('button, [tabindex]:not([tabindex="-1"])')
    target?.focus({ preventScroll: true })
  }
  return 'shown'
}
